import type { Id, TableNames } from "@v1/backend/convex/_generated/dataModel";
import { looksLikeConvexId } from "@v1/backend/logic/ids/convex_id";

/** Drops synthetic UI ids (e.g. optimistic `pending-optimistic-…`) before Convex `v.id("users")` queries. */
export function parseConvexUserId(id: string): Id<"users"> | null {
  return looksLikeConvexId(id) ? (id.trim() as Id<"users">) : null;
}

/** Drops synthetic UI ids before Convex `v.id("files")` queries; trimmed, deduplicated. */
export function filterConvexFileIds(ids: readonly string[]): Id<"files">[] {
  const unique = new Set<string>();
  const result: Id<"files">[] = [];
  for (const raw of ids) {
    if (!looksLikeConvexId(raw)) continue;
    const id = raw.trim();
    if (unique.has(id)) continue;
    unique.add(id);
    result.push(id as Id<"files">);
  }
  return result;
}

/** URL segment → id of the given table; null when it cannot be a Convex id. */
export function parseConvexIdOf<TTable extends TableNames>(id: string): Id<TTable> | null {
  return looksLikeConvexId(id) ? (id.trim() as Id<TTable>) : null;
}
